import React from "react";
import ReliefForm from "./reliefTurnForm.view";

const ReliefFormContainer = ({ onCancel, onSuccess, observations }) => {
  const handleSubmit = async (values) => {
    try {
      onSuccess(values);
    } catch (error) {
      console.log("Error", error);
    }
  };
  return (
    <>
      <ReliefForm onSubmit={handleSubmit} observations={observations} />
    </>
  );
};

ReliefFormContainer.propTypes = {};

export default ReliefFormContainer;
